import logoLogin from '../assets/images/logo_login.png'
import logoMenu from '../assets/images/logo_menu.png'
import loginBackground from '../assets/images/BACKGROUND.png'
import img404 from '../assets/images/404.png'

import { ReactComponent as userNameInput } from '../assets/icons/user.svg'
import { ReactComponent as lockPasswordInput } from '../assets/icons/lock.svg'
import { ReactComponent as eyeOffPasswordInput } from '../assets/icons/off.svg'
import { ReactComponent as eyePasswordInput } from '../assets/icons/eye.svg'
import { ReactComponent as emailInput } from '../assets/icons/mail.svg'
import { ReactComponent as burgerMenu } from '../assets/icons/big.svg'
import { ReactComponent as search } from '../assets/icons/search.svg'
import { ReactComponent as noti } from '../assets/icons/Variant3.svg'
import { ReactComponent as userFill } from '../assets/icons/user fill.svg'
import { ReactComponent as profileDown } from '../assets/icons/down.svg'
import { ReactComponent as chatDrawer } from '../assets/icons/box.svg'
import { ReactComponent as docDrawer } from '../assets/icons/7.svg'
import { ReactComponent as folderDrawer } from '../assets/icons/folder.svg'
import { ReactComponent as barDrawer } from '../assets/icons/bar.svg'
import { ReactComponent as securityDrawer } from '../assets/icons/security.svg'
import { ReactComponent as dotMenu } from '../assets/icons/dot menu.svg'
import { ReactComponent as circleButton } from '../assets/icons/circle.svg'
import { ReactComponent as editTable } from '../assets/icons/1.svg'

import iconAddPhoto from '../assets/icons/iconAddPhoto.svg'
import iconTrash from '../assets/icons/iconTrash.svg'
import previoes_slice from '../assets/icons/previous_slice.svg'
import next_slice from '../assets/icons/next_slice.svg'
import meatball from '../assets/icons/meatball'
import dropdownEdit from '../assets/icons/dropdownEdit.svg'
import dropdownTrash from '../assets/icons/dropdownTrash.svg'
import close from '../assets/icons/close.svg'
import print from '../assets/icons/print.svg'
import add from '../assets/icons/add.svg'
import Shuffle from '../assets/icons/shuffle.svg'
import dropdown from '../assets/icons/dropdown.svg'

export const logo = {
    logoLogin: logoLogin,
    logoMenu: logoMenu,
}

export const background = {
    loginBackground: loginBackground,
}

export const imgs = {
    img404: img404
}

export const icons = {
    userNameInput: userNameInput,
    lockPasswordInput: lockPasswordInput,
    eyePasswordInput: eyePasswordInput,
    eyeOffPasswordInput: eyeOffPasswordInput,
    emailInput: emailInput,
    burgerMenu: burgerMenu,
    search: search,
    noti: noti,
    userFill: userFill,
    profileDown: profileDown,
    chatDrawer: chatDrawer,
    docDrawer: docDrawer,
    folderDrawer: folderDrawer,
    barDrawer: barDrawer,
    securityDrawer: securityDrawer,
    dotMenu: dotMenu,
    circleButton: circleButton,
    editTable: editTable,

    iconAddPhoto: iconAddPhoto,
    iconTrash: iconTrash,
    previoes_slice: previoes_slice,
    next_slice: next_slice,
    meatball: meatball,
    dropdownEdit: dropdownEdit,
    dropdownTrash: dropdownTrash,
    close: close,
    print: print,
    add: add,
    Shuffle: Shuffle,
    dropdown: dropdown
}
